var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"container sm:w-[558px] m-auto mt-10 rounded-lg sm:px-9 pb-8 sm:pb-14"},[_c(_setup.LoginTitle),_c(_setup.LoginForm),_c(_setup.RedirectContainer),_c(_setup.OtherLogin),_c(_setup.PageFooter)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }